import { render, staticRenderFns } from "./TermsHaveAcceptCard.vue?vue&type=template&id=72a0517c&scoped=true"
import script from "./TermsHaveAcceptCard.vue?vue&type=script&lang=js"
export * from "./TermsHaveAcceptCard.vue?vue&type=script&lang=js"
import style0 from "./TermsHaveAcceptCard.vue?vue&type=style&index=0&id=72a0517c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0517c",
  null
  
)

export default component.exports